import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';
import AdminActions from './AdminActions';
import axios from "axios"
const override = css`
  display: block;
  margin: 0 auto;
`;

const EmployerTable = () => {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchEmployers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobrecruiter/allJobEmployer`, {
        
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
   
          setEmployers(response.data);
          console.log(response.data, "your response")
      
      } catch (error) {
        console.error('Fetch Error:', error);
        toast.error('An error occurred while fetching employers');
      } finally {
        setLoading(false);
      }
    };
    fetchEmployers();
  }, []);

  const filteredEmployers = employers?.filter(employer =>
    `${employer.companyName}`.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-900">
        <ClipLoader color="#16F95AFF" css={override} size={50} />
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-900 min-h-screen text-white">
      <h1 className="text-3xl font-bold mb-6 text-green-500">Job Employers - {employers?.length > 0 ? employers.length : 0}</h1>
      <div className="mb-6">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by company name..."
          className="p-3 border border-gray-700 rounded-md w-full md:w-1/3 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>
      <div className="overflow-x-auto shadow-lg rounded-lg">
        <table className="w-full bg-gray-800 border-collapse">
          <thead>
            <tr className="bg-gray-700">
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Company Name</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Email</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Contact Person</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Size</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Address</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">State</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Local Government</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Country</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Avatar</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Phone Number</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Employer Type</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">User Type</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Listed Jobs</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Certificate</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Employers</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Reports Made</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Job Offers</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Reports Gotten</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Notifications</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Is Blacklisted</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Is Verified</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Last Login</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Unique Number</th>
              <th className="border-b border-gray-600 p-4 text-left text-green-400">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmployers.map((employer) => (
              <tr key={employer._id} className="border-b border-gray-600 hover:bg-gray-700 transition-colors">
                <td className="border-r border-gray-600 p-4">{employer.companyName}</td>
                <td className="border-r border-gray-600 p-4">{employer.email}</td>
                <td className="border-r border-gray-600 p-4">{employer.contactPerson ? employer.contactPerson.toString() : 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{employer.size}</td>
                <td className="border-r border-gray-600 p-4">{employer.address}</td>
                <td className="border-r border-gray-600 p-4">{employer.state}</td>
                <td className="border-r border-gray-600 p-4">{employer.localGovernment}</td>
                <td className="border-r border-gray-600 p-4">{employer.country}</td>
                <td className="border-r border-gray-600 p-4">{employer.avatar || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{employer.phoneNumber}</td>
                <td className="border-r border-gray-600 p-4">{employer.employerType}</td>
                <td className="border-r border-gray-600 p-4">{employer.userType}</td>
                <td className="border-r border-gray-600 p-4">{employer.listedJobs?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{employer.certificate || 'N/A'}</td>
                <td className="border-r border-gray-600 p-4">{employer.employers?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{employer.reportsMade?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{employer.jobOffers?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{employer.reportsGotten?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{employer.notifications?.length || 0}</td>
                <td className="border-r border-gray-600 p-4">{employer.isBlacklisted ? 'Yes' : 'No'}</td>
                <td className="border-r border-gray-600 p-4">{employer.isVerified ? 'Yes' : 'No'}</td>
                <td className="border-r border-gray-600 p-4">{new Date(employer.lastLogin).toLocaleString()}</td>
                <td className="border-r border-gray-600 p-4">{employer.uniqueNumber}</td>
                <td className="border-r border-gray-600 p-4">
                  {localStorage.getItem('userType') === 'admin' && (
                    <AdminActions employerId={employer._id} isBlacklisted={employer.isBlacklisted} />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployerTable;